import { Label, UIHeading3, UIHeading4, Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PriceDiscount.css';

interface IPriceDiscountProps {
  newPrice: string;
  oldPrice: string;
  percent: string;
  isBooked?: boolean;
}

export const PriceDiscount: React.FC<IPriceDiscountProps> = ({ newPrice, oldPrice, percent, isBooked }) => {
  /* istanbul ignore next */
  const color = isBooked ? 'text-secondary-default' : 'text-primary-default';

  return (
    <span className={styles['price-discount']}>
      <Responsive desktop tablet>
        <UIHeading4 color={color}>{newPrice}</UIHeading4>
      </Responsive>
      <Responsive phone>
        <UIHeading3 color={color}>{newPrice}</UIHeading3>
      </Responsive>
      <Label background="accent-positive-primary" color="text-inverted-default">
        {percent}
      </Label>
      <span className={styles['old-price']}>{oldPrice}</span>
    </span>
  );
};
